import { Component, Renderer2, AfterViewInit } from "@angular/core";
import { fromEvent, Observable, Subscription } from "rxjs";
import { MessagingService } from "src/app/services/messaging.service";

import {
  Router,
  ActivatedRoute,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  ResolveEnd
} from "@angular/router";

// import { ConnectionService } from "./services/connection.service";
import { AuthService } from "./services/auth.service";
import { ServiceService } from "./services/service.service";
import { UserIdleService } from "angular-user-idle";
declare let gtag: Function;
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent {
  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;
  loading: boolean = true;
  subscriptions: Subscription[] = [];
  globalListenFunc: Function;
  connectionStatusMessage: string;
  connectionStatus: string;
  message;
  showExtraComponents: boolean;

  constructor(
    private userIdle: UserIdleService,
    private renderer: Renderer2,
    private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private service: ServiceService,
    private messagingService: MessagingService
  ) {
    this.loading = true;
    const userId = "doctoreRXMD2019";
    this.messagingService.requestPermission(userId);
    this.messagingService.receiveMessage();
    this.message = this.messagingService.currentMessage;

    this.router.events.subscribe(event => {
      if (event instanceof ResolveEnd) {
        // gtag('config', 'G-W7P7Q641XC',
        // gtag('config', 'G-36NNYTGRZT',
        //   {
        //     'page_title': event.urlAfterRedirects.replace('/', ''),
        //     'page_path': event.urlAfterRedirects
        //   }
        // );
      }
    }
    )

  }

  showExtraComponentsValue() {
    // on route change to '/login', set the variable showHead to false
    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if ((event['url'] == '/login' || event['url'] == '/signup')) {
          this.showExtraComponents = false;
        } else {
          if (localStorage.getItem('access_token'))
            this.showExtraComponents = true;
        }
      }
    });

    return this.showExtraComponents;
  }

  ngAfterViewInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel
      ) {
        this.loading = false;
      }
    });
  }

  ngOnInit(): void {
    /**
     * Get the online/offline status from browser window
     */

    this.onlineEvent = fromEvent(window, "online");
    this.offlineEvent = fromEvent(window, "offline");

    this.subscriptions.push(
      this.onlineEvent.subscribe(e => {
        this.connectionStatusMessage = "Back to online";
        this.connectionStatus = "online";
        //this.conn.setStatus(this.connectionStatus);
        console.log("Online...");
      })
    );

    this.subscriptions.push(
      this.offlineEvent.subscribe(e => {
        this.connectionStatusMessage =
          "Connection lost! You are not connected to internet";
        this.connectionStatus = "offline";
        //this.conn.setStatus(this.connectionStatus);
        console.log("Offline...");
      })
    );

    this.userIdle.startWatching();

    this.globalListenFunc = this.renderer.listen("document", "mousemove", e => {
      this.restart();
    });

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe(count => {
    });

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      this.auth.logoutUser();
      localStorage.setItem("error", "true");
      localStorage.setItem(
        "errMessage",
        "You are logged out automatically because of inactivity."
      );
      this.router.navigate(["/login"]);
    });

    // this.service.getData("setting/", 2000).subscribe((data: any) => {
    //   //$(".overlay-loading").hide();
    //   if (data == "Timeout") {
    //     console.log(
    //       "I am sorry but we are facing some problem with server. Please wait for some time."
    //     );
    //   } else if (data == "OFFLINE") {
    //     console.log(
    //       "I am sorry but we are facing some problem with server OFFLINE. Please wait for some time."
    //     );
    //   } else {
    //     if (typeof data === "undefined" || data["success"] == "0") {
    //     } else {
    //       localStorage.setItem("settings", JSON.stringify(data["data"]));
    //     }
    //   }
    // });
  }
  stop() {
    this.userIdle.stopTimer();
  }

  stopWatching() {
    this.userIdle.stopWatching();
  }

  startWatching() {
    this.userIdle.startWatching();
  }

  restart() {
    this.userIdle.resetTimer();
  }

  ngOnDestroy(): void {
    /**
     * Unsubscribe all subscriptions to avoid memory leak
     */
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
